module.exports = __webpack_public_path__ + "static/img/son7.aca4cd41.png";